import React from 'react';

import Button, { Props as ButtonProps } from '@ott/button';
import SuccessIcon from '@ott/icon-success';
import Modal from '@ott/modal';

import styles from './SuccessModal.scss';

type Props = {
  isOpen?: boolean;
  title: string;
  description: React.ReactNode | string;
  actionButtonPurpose?: ButtonProps['purpose'];
  actionButtonText: string;
  fullScreenOnMobile?: boolean;
  preventUserCloseModal?: boolean;
  customContentOptions?: {
    forceVerticalButtonLayout?: boolean;
    transparent?: boolean;
    size?: 'small' | 'medium' | 'wide';
    childrenClassNames?: {
      header?: string;
      closer?: string;
      footer?: string;
    };
  };
  onClose: VoidFunction;
  onAction: VoidFunction;
};

const SuccessModal = ({
  isOpen = true,
  title,
  description,
  actionButtonPurpose = 'defaultPurpose',
  actionButtonText,
  fullScreenOnMobile = false,
  customContentOptions = {},
  preventUserCloseModal,
  onClose,
  onAction,
}: Props) => {
  return (
    <Modal
      isOpen={isOpen}
      fullScreenOnMobile={fullScreenOnMobile}
      specificLocators="success-modal"
      contentOptions={{
        icon: <SuccessIcon />,
        title,
        footerContentNode: (
          <Button
            purpose={actionButtonPurpose}
            withFullWidth={true}
            onClick={onAction}
            specificLocators="success-modal-action-button"
          >
            {actionButtonText}
          </Button>
        ),
        ...customContentOptions,
      }}
      preventUserClose={preventUserCloseModal}
      onClose={onClose}
    >
      <div id="virtual-card-success-modal" className={styles.description}>
        {description}
      </div>
    </Modal>
  );
};

export default React.memo(SuccessModal);
